export default class MatchMediaWatcher {
  constructor() {
    this.mql = null;
    this.handler = null;
  }

  callback(cb) {
    cb(this.mql.matches);
  }

  initWatcher(mediaQuery) {
    this.mql = window.matchMedia(mediaQuery);
  }

  execute() {
    this.handler();
  }

  static isSupportAddEventListener() {
    return 'addEventListener' in window.matchMedia('');
  }

  static getWatcher() {
    if (MatchMediaWatcher.isSupportAddEventListener()) {
      return new ModernWayAddHandler();
    }

    return new DeprecatedWayAddHandler();
  }
}

class ModernWayAddHandler extends MatchMediaWatcher {
  addHandler(mediaQuery, cb) {
    this.handler = this.callback.bind(this, cb);
    this.initWatcher(mediaQuery);
    this.mql.addEventListener('change', this.handler);
  }

  removeHandler() {
    this.mql.removeEventListener('change', this.handler);
  }
}

class DeprecatedWayAddHandler extends MatchMediaWatcher {
  addHandler(mediaQuery, cb) {
    this.handler = this.callback.bind(this, cb);
    this.initWatcher(mediaQuery);
    this.mql.addListener(this.handler);
  }

  removeHandler() {
    this.mql.removeListener(this.handler);
  }
}
